import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function TopCollections() {

    const options = {
          margin:20,
          loop:true,
          autoplay: true,   
          dots:false,
          autoWidth:true,
          slideTransition: 'linear',
          autoplayTimeout: 1500,
          autoplaySpeed: 1500,
      };

      const optionsSecond = {
          margin:20,
          loop:true,
          autoplay: true,   
          dots:false,
          autoWidth:true,
          slideTransition: 'linear',
          autoplayTimeout: 2500,
          autoplaySpeed: 2500,
      };
    
      function handleSlideChange(event) {
        console.log('Active item:', event.item.index);
      }
      
  return (
<div className="profile-scroll-wrap pb-100">
  <div className="container">
    <div className="row justify-content-center mb-50">
      <div className="col-md-8 text-center">
        <h2 className="h1 lh-2 mb-0 text-gray-900 dark-text rajdhani-600">Top creators avatar collection</h2>
        <p className="px-md-5 mt-2 text-gray-800 dark-text rajdhani-600 font-sm">Unveil a world of breathtaking avatars collections. Meticulously crafted by our most talented creators.</p>
      </div>
    </div>
  </div>
  <div className="carousel-wrap h-70 ovh">
    <OwlCarousel className="owl-theme auto-width owl-carousel-visible author-collection" {...options}>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-3.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-4.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Alice Hope</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@alice_hope</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Peter Parker</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Pandit Coast</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@pandit_coast</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-5.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-6.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-7.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-8.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-9.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-3.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-4.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Alice Hope</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@alice_hope</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Peter Parker</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Pandit Coast</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@pandit_coast</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-5.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-6.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-7.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-8.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-9.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
    </OwlCarousel>
  </div>
  <div className="carousel-wrap h-70 ovh mt-4 ps-5">
    <OwlCarousel className="owl-theme auto-width-2 owl-carousel-visible author-collection" {...optionsSecond}>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-3.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-4.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Alice Hope</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@alice_hope</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Peter Parker</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Pandit Coast</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@pandit_coast</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-5.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-6.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-7.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-8.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-9.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-5.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-6.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-7.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-8.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-9.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-3.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-4.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Alice Hope</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@alice_hope</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Peter Parker</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Pandit Coast</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@pandit_coast</h6>
          </div>
        </div>
      </div>
    </OwlCarousel>
  </div>
  <div className="carousel-wrap h-70 ovh mt-4">
    <OwlCarousel className="owl-theme auto-width owl-carousel-visible author-collection" {...options}>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-3.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-4.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Alice Hope</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@alice_hope</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Peter Parker</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Pandit Coast</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@pandit_coast</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-5.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-6.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-7.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-8.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg d-flex w-auto bg-gray-100 flex-row gap-2 rounded-pill ovh p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-9.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-3.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-5.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Novita Thomson</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@nobita_thumbson</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-6.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Aditiya Gupta</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-7.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-8.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/team-9.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Medica Deo</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@medica_deo</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/avater-4.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Alice Hope</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@alice_hope</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-1.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Peter Parker</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@peter_parker</h6>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="author-div light-bg ovh h-60 d-flex w-auto flex-row gap-2 rounded-pill ovh bg-gray-100 p-2 pe-4">
          <figure className="avater mb-0"><img src="images/n-2.png" alt="user" className="w-45" /></figure>
          <div className="me-auto text-grey-500 text-start">
            <h5 className="text-gray-900 dark-text rajdhani-600 h6 lh-26 text-start m-0">Pandit Coast</h5>
            <h6 className="text-gray-500 lh-1 mb-0 font-xs rajdhani-500">@pandit_coast</h6>
          </div>
        </div>
      </div>
    </OwlCarousel>
  </div>
</div>

  )
}
